import { Injectable } from '@angular/core';

import { includes } from 'lodash';

import { BcCalendarEvent, BcCalendarEventStatus, BcCalendarResource } from '@bayclubs/calendar';
import { CalendarEventModel, LocationModel } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root'
})
export class ClassesCalendarEventBuilderService {
    constructor() {}

    public buildEvents(events: CalendarEventModel[], resources: BcCalendarResource[], clubId: string): BcCalendarEvent[] {
        const resourceIds = resources && resources.map(r => r.id);
        const calendarEvents = events
            .filter(ev => includes(resourceIds, ev.location?.id))
            .map(
                event =>
                    ({
                        date: { value: event.date.value },
                        displayText: event.name,
                        id: event.id,
                        timeFromInMinutes: event.originalTimeFromInMinutes,
                        timeToInMinutes: event.originalTimeToInMinutes,
                        //customCssClass: this.getCustomCssName(event),
                        resource: resources.find(r => r.id === event.location.id),
                        status: BcCalendarEventStatus.Active,
                        clickable: true,
                        originalEvent: event
                    } as BcCalendarEvent)
            );
            if (events.some(ev => ev.location === null)) {
               calendarEvents.push(
                ...events.filter(ev => ev.location === null)
                .map(
                    event =>
                        ({
                            date: { value: event.date.value },
                            displayText: event.name,
                            id: event.id,
                            timeFromInMinutes: event.originalTimeFromInMinutes,
                            timeToInMinutes: event.originalTimeToInMinutes,
                            //customCssClass: this.getCustomCssName(event),
                            resource: resources.find(r => r.id === 'other'),
                            status: BcCalendarEventStatus.Active,
                            externalType: clubId,
                            clickable: true,
                            originalEvent: event
                        } as BcCalendarEvent)
                ));
            }
            return calendarEvents;
    }

    public buildCourtResources(resources: LocationModel[], events: CalendarEventModel[], doNotAddOtherResource: boolean): BcCalendarResource[] {
        if (resources !== null) {
            resources = [...resources];
            resources.sort((a,b) => a.order - b.order);
            const calendarResources = resources.map(
                res =>
                    ({
                        id: res.id,
                        displayText: res.name,
                        originalResource: res
                    } as BcCalendarResource)
            );
            if (!doNotAddOtherResource && events.some(ev => ev.location === null)) {
                calendarResources.push({id: 'other', displayText: 'Other'} as BcCalendarResource)
            }
            return calendarResources;
        } else {
            return [];
        }
    }
}
